import { render } from "./ContactUs.vue?vue&type=template&id=1bdf8062&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=1bdf8062&lang=less&scoped=true"

import exportComponent from "C:\\project\\digirebar\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdf8062"]])

export default __exports__